import { assignGroupToDealerSuccess, findOneByNameSuccess } from './actions';
import * as actionTypes from './actionTypes';

const notifications = {
  checklist: {
    success: {
      id: 'group_config.assign_checklist.success',
      defaultMessage: "The checklist has been successfully assigned to all group's dealerships",
    },
    failure: {
      id: 'group_config.assign_checklist.failure',
      defaultMessage: 'An error occurred when assigning the checklist',
    },
  },
  offer: {
    success: {
      id: 'group_config.assign_offer.success',
      defaultMessage: "The list has been successfully assigned to all group's dealerships",
    },
    failure: {
      id: 'group_config.assign_offer.failure',
      defaultMessage: 'An error occurred when assigning the list',
    },
  },
  extra: {
    success: {
      id: 'group_config.assign_extra.success',
      defaultMessage: "The extra has been successfully assigned to all group's dealerships",
    },
    failure: {
      id: 'group_config.assign_extra.failure',
      defaultMessage: 'An error occurred when assigning the extra',
    },
  },
  questionModel: {
    success: {
      id: 'group_config.assign_question_form_model.success',
      defaultMessage: "The question form model has been successfully assigned to all group's dealerships",
    },
    failure: {
      id: 'group_config.assign_question_form_model.failure',
      defaultMessage: 'An error occurred when assigning the question form model',
    },
  },
};

/** @type {Record<string, import("modules/app/types").SimpleRequestConfig>} */
const simpleRequests = {
  // CRUD Requests
  [actionTypes.UPDATE_GROUP_REQUEST]: {
    notifications: {
      success: {
        id: 'page.group.config.update.success',
        defaultMessage: 'Group configuration has been saved successfully.',
      },
      failure: {
        id: 'page.group.config.update.failure',
        defaultMessage: 'An error occurred while saving the group configuration.',
      },
    },
  },
  [actionTypes.CREATE_GROUP_REQUEST]: {
    notifications: {
      success: {
        id: 'createGroupSuccess',
        defaultMessage: 'The group has been added with success.',
      },
      failure: {
        id: 'createGroupFailure',
        defaultMessage: 'An error occurred during the group creation.',
      },
    },
  },
  // Other requests
  [actionTypes.FETCH_GROUPS_BY_EXTENSION_REQUEST]: {},
  [actionTypes.FIND_ONE_BY_NAME]: {
    callbacks: {
      success: (data, meta, { payload: parentPayload }) =>
        findOneByNameSuccess(parentPayload.request.params.name, data.status !== 404, meta),
    },
  },
  [actionTypes.ASSIGN_ENTITY_FROM_GROUP_REQUEST]: {
    notifications: {
      success: (_, { payload, meta }) => {
        const { entityName } = payload;
        const notification = notifications[meta.notificationKey ?? meta.source ?? entityName];
        return notification?.success;
      },
      failure: (_, { payload, meta }) => {
        const { entityName } = payload;
        const notification = notifications[meta.notificationKey ?? meta.source ?? entityName];
        return notification?.failure;
      },
    },
  },
  [actionTypes.ASSIGN_TEMPLATE_FROM_GROUP_REQUEST]: {
    notifications: {
      success: {
        id: 'group_config.assign_template.success',
        defaultMessage: "The template is successfully assigned in all group's dealerships",
      },
      failure: {
        id: 'group_config.assign_template.failure',
        defaultMessage: 'An error occurred when assigning the template',
      },
    },
  },
  [actionTypes.ASSIGNMENT_GROUP_TO_DEALERS_REQUEST]: {
    notifications: {
      failure: {
        id: 'page.assignments.modal.notifications.failure',
        defaultMessage: 'An error occurred while assigning the configuration.',
      },
    },
    callbacks: {
      success: (_, meta, { payload }) => {
        const { entity, request } = payload;
        const { data } = request;
        return assignGroupToDealerSuccess(entity, data, meta);
      }
    }
  },
  [actionTypes.FETCH_GROUP_CURRENCY]: {
    notifications: {
      failure: () => undefined,
    },
  }
};

export default simpleRequests;
